import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { emailValidation, URL_PATTERN } from 'app/core/constants/constants';
import { LocalStorageService } from 'app/core/services/localstorage.service';

@Component({
  selector: 'app-product-subscription-alert',
  templateUrl: './product-subscription-alert.component.html',
  styleUrls: ['./product-subscription-alert.component.scss']
})
export class ProductSubscriptionAlertComponent implements OnInit {

  productSubscriptionData: any;

  emailRegExp: RegExp = new RegExp(emailValidation);

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any, private dialogRef: MatDialogRef<ProductSubscriptionAlertComponent>,
    private localStorageService: LocalStorageService) {
    this.productSubscriptionData = dialogData?.data;
  }

  ngOnInit(): void {
  }

  onActionClick(): void {
    const paymentActionLink: string = this.productSubscriptionData?.action_btn?.link ?? '';
    if (!paymentActionLink) {
      return;
    }
    if (URL_PATTERN.test(paymentActionLink)) {
      window.open(paymentActionLink);
      return;
    }
    if (this.emailRegExp.test(paymentActionLink)) {
      window.location.href = `mailto:${paymentActionLink}`;
    }
  }

  closeDialog(): void {
    if (this.productSubscriptionData?.dismissable) {
      this.localStorageService.setLocalStorage('product_payment_closed', true);
      this.dialogRef.close();
    }
  }

}
